module.exports = __webpack_public_path__ + "img/pe.ea95116f.svg";